import { DatePicker } from "@material-ui/pickers";
import React, { Component, useEffect, useState } from "react";
// import {
//   Form,
//   Loader,
//   Dimmer,
//   Button,
//   Divider,
//   Message,
// } from "semantic-ui-react";
import InputComponent from "./input_component";
import SelectComponent from "./select_component";
import { useDispatch, useSelector } from "react-redux";
// import UploadFilesComponent from "./uploadButton_component";
import DatePickerSelectComponent from "./select_with_datepicker_component";
import SelectWithMultiSelect from "./select_with_multi_select";
import InputWithDropdownComponent from "./input_with_dropdown";
import MultipleSelect from "./multi_select_component";
import AddressComponent from "./address_component";
import EmpAddressComponent from "./emp_address_component";
import DatePickerComponent from "./datepicker_component";
import DateTimePickerComponent from "./dateTimerPicker_component";
import UploadComponent from "./upload_component";
import SingleSelect from "./growing_dropdown";
import PhoneInputComp from "./phone_component";
import UploadFilesComponent from "./upload_files_component";
// import GroupDropdown from "./grouped_dropdown";
import MultipleSelectChip from "./multi_select_chip";
import CustomSelectMulti from "./customSelectMulti";
import CheckedDropdown from "./checkedMultiSelect";
import CheckboxesGroupComponent from "./checkbox";
import SelectSpecific from "./select_specific";
import CustomSingleCheckbox from "./CustomSingleCheckbox";
import TimeComponent from "./timepicker_component";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import ImageCrop from "../image-crop";
import CustomCheckboxes from "./CustomCheckboxes";
import CustomLabel from "./CustomLabel";

const useStyles = makeStyles(() => ({
  formDiv: {
    width: "80%",
    margin: "0 auto 55px 10px",
    paddingTop: "5%",
    paddingBottom: "5%",
    "& .MuiGrid-container": {
      alignItems: "center",
    },
  },
}));

export default function FormComponent(props: any) {
  const classes = useStyles();
  const renderInputComponents = (
    componentObject: any,
    indexer: any,
    index: any,
    pIndex: any
  ) => {
    componentObject["indexKey"] = indexer;
    componentObject["index"] = index;
    if (!componentObject?.isDynamicField)
      componentObject["isDynamicField"] = pIndex;
    if (!componentObject?.moduleName)
      componentObject["moduleName"] = props?.moduleName;
    switch (componentObject.componentType) {
      case "input":
        return <InputComponent key={index} componentObject={componentObject} />;
      case "select":
        return (
          <SelectComponent key={index} componentObject={componentObject} />
        );
      case "growingDropdown":
        return <SingleSelect key={index} componentObject={componentObject} />;
      case "MultipleSelect":
        return <MultipleSelect key={index} componentObject={componentObject} />;
      case "datePicker":
        return (
          <DatePickerComponent key={index} componentObject={componentObject} />
        );
      case "dateTimePicker":
        return (
          <DateTimePickerComponent
            key={index}
            componentObject={componentObject}
          />
        );
      case "selectWithDatePicker":
        return (
          <DatePickerSelectComponent
            key={index}
            componentObject={componentObject}
          />
        );
      case "selectWithMultiSelect":
        return (
          <SelectWithMultiSelect
            key={index}
            componentObject={componentObject}
          />
        );
      case "uploadFiles":
        return (
          <UploadFilesComponent key={index} componentObject={componentObject} />
        );
      case "inputWithDropdown":
        return (
          <InputWithDropdownComponent
            key={index}
            componentObject={componentObject}
          />
        );
      case "address":
        return (
          <AddressComponent key={index} componentObject={componentObject} />
        );
      case "empAddress":
        return (
          <EmpAddressComponent key={index} componentObject={componentObject} />
        );
      case "upload":
        // return <UploadComponent key={index} componentObject={componentObject} />;
        return (
          <UploadFilesComponent key={index} componentObject={componentObject} />
        );
      case "imageUploadWithCrop":
        return <ImageCrop key={index} componentObject={componentObject} />;
      case "phone":
        return <PhoneInputComp key={index} componentObject={componentObject} />;
      case "SelectSpecific":
        return (
          <Grid container key={index} style={{ marginBottom: 20 }}>
            <Grid item xs={12} md={4}>
              {componentObject.label}
            </Grid>
            <Grid item xs={12} md={7}>
              <SelectSpecific
                id={componentObject.id}
                name={componentObject.name}
                componentObject={componentObject}
                addNewHandler={componentObject.addNewHandler}
                itemArr={componentObject.itemArr}
                placeholder={componentObject.placeholder}
                disabled={componentObject.disabled}
                // parentcall={onChangeMultiItem}
                // value={getMultiSelectValueById(componentObject)}
                moduleName={componentObject.moduleName}
              />
            </Grid>
          </Grid>
        ); // case "multiSelectChip":
      //   return <MultipleSelectChip key={index} componentObject={componentObject} />;

      // case "GroupDropdown":
      //   return (
      //     // <GroupDropdown key={index} componentObject={componentObject} />;
      //     <Grid container key={index} style={{ marginBottom: 20 }}>
      //       <Grid item xs={12} md={4}>
      //         {componentObject.label}
      //       </Grid>
      //       <Grid item xs={12} md={7}>
      //         <GroupDropdown
      //           id={componentObject.id}
      //           name={componentObject.name}
      //           componentObject={componentObject}
      //           addNewHandler={componentObject.addNewHandler}
      //           itemArr={componentObject.itemArr}
      //           // parentcall={onChangeMultiItem}
      //           placeholder={componentObject.placeholder}
      //         // value={getMultiSelectValueById(componentObject)}
      //         />

      //         {/* <GroupDropdown
      //       id={componentObject.id}
      //       name ={componentObject.name}
      //       addNewHandler={componentObject.addNewHandler}
      //       itemArr={componentObject.itemArr}
      //       parentcall={onChangeMultiItem}
      //       placeholder={componentObject.placeholder}
      //       value={getMultiSelectValueById(componentObject.id)}
      //                     /> */}
      //       </Grid>
      //     </Grid>
      //   );
      case "CustomSelectMulti":
        return (
          <Grid container key={index} style={{ marginBottom: 20 }}>
            <Grid item xs={12} md={4}>
              {componentObject.label}
            </Grid>
            <Grid item xs={12} md={7}>
              <CustomSelectMulti
                id={componentObject.id}
                name={componentObject.name}
                drop_down={componentObject.drop_down}
                field_name={componentObject.field_name}
                componentObject={componentObject}
                addNewHandler={componentObject.addNewHandler}
                addNewFlag={componentObject.addNewFlag}
                itemArr={componentObject.itemArr}
                // parentcall={onChangeMultiItem}
                placeholder={componentObject.placeholder}
                // value={getMultiSelectValueById(componentObject)}
              />
            </Grid>
          </Grid>
        );
      case "multiSelectChip":
        return (
          <Grid container key={index} style={{ marginBottom: 20 }}>
            <Grid item xs={12} md={4}>
              {componentObject.label}
            </Grid>
            {console.log("Arr", componentObject.itemArr)}
            <Grid item xs={12} md={7}>
              <MultipleSelectChip
                id={componentObject.id}
                name={componentObject.name}
                // componentObject={componentObject}
                addNewHandler={componentObject.addNewHandler}
                itemArr={componentObject.itemArr}
                // parentcall={onChangeMultiItem}
                placeholder={componentObject.placeholder}
                // value={getMultiSelectValueById(componentObject)}
                moduleName={componentObject.moduleName}
                key={index}
                componentObject={componentObject}
                disabled={componentObject.disabled}
              />
            </Grid>
          </Grid>
        );

      case "DynamicFields":
        const selectedOptions = componentObject.selectOptions.map(
          (item: any) => ({ ...item, label: item.value })
        );

        return (
          <React.Fragment key={index}>
            <MultipleSelect
              reactSelect={true}
              key={index}
              componentObject={{ ...componentObject, itemArr: selectedOptions }}
              selectedOptions={selectedOptions}
            />
            {/* @ts-ignore */}
            {/* <Select key={index} value={componentObject.value} onChange={(e) => componentObject.handleChange(e, index,)} isMulti options={selectedOptions} /> */}
            {componentObject?.fields.map((field: any, idx: number) => {
              field["index"] = idx;
              field["isDynamicField"] = true;
              switch (field.fieldType) {
                case "dropdown":
                  return <SelectComponent key={idx} componentObject={field} />;

                case "input":
                  return <InputComponent key={idx} componentObject={field} />;
                default:
                  return null;
              }
            })}
          </React.Fragment>
        );
      case "checkedDropdown":
        return (
          <CheckedDropdown key={index} componentObject={componentObject} />
        );
      case "CheckboxesGroup":
        return (
          <CheckboxesGroupComponent
            key={index}
            componentObject={componentObject}
          />
        );
      case "checkboxes":
        return (
          <CustomCheckboxes key={index} componentObject={componentObject} />
        );
      case "singleCheckbox":
        return (
          <CustomSingleCheckbox key={index} componentObject={componentObject} />
        );
      case "rederComponent":
        return (
          <div style={{ marginTop: "5%" }}>{componentObject.component}</div>
        );
      case "onlyLabel":
        return <CustomLabel key={index} componentObject={componentObject} />;
      case "timeComponent":
        return <TimeComponent key={index} componentObject={componentObject} />;
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <form autoComplete="off">
        <div style={props.style && props.style} className={classes.formDiv}>
          {props.children.map((input: any, index: any) => {
            let indexer =
              input["componentType"] === "dropdown"
                ? input["multiple"] &&
                  input["dropdownValue"] &&
                  input["dropdownValue"].length > 0
                  ? input["dropdownValue"][0]
                  : input["dropdownValue"]
                  ? input["dropdownValue"]
                  : index
                : index;
            indexer = indexer.toString() + "-" + index;
            return renderInputComponents(input, indexer, index, props.pIndex);
          })}
        </div>
      </form>
    </React.Fragment>
  );
}
